const Contact =()=>{
    
    return(
        <section id='contact'className="hid md:h-1/2 m-6 md:m-8">
                <div>
                <h1 className="header">LET'S CONNECT</h1>
                <div className="grid justify-center mt-8 md:grid-cols-2 gap-2">
                    <div>
                        <div className="flex justify-center space-x-2 ">
                            <a href="https://github.com/oshela">
                            <img src="/img/icons/github.PNG" className="icons"alt="" />
                            </a>
                            <a href="https://discord.com/channels/@osh_la#7633">
                            <img src="/img/icons/discord.PNG" className="icons"alt="" />
                            </a>
                            <a href="https://www.linkedin.com/in/abimiku-oshela-8b1361170/">
                            <img src="/img/icons/linkedin.PNG" className="icons"alt="" />
                            </a>
                            <a href="https://medium.com/@abimikuoshela">
                            <img src="/img/icons/medium.PNG" className="icons"alt="" />
                            </a>
                            <a href="https://twitter.com/osh__la">
                            <img src="/img/icons/twitter.PNG" className="icons"alt="" />
                            </a>
                            <a href="mailto:<nowiki>abimikuoshela@gmail.com?subject=From My Portfolio">
                            <img src="/img/icons/gmaill.PNG" className="icons"alt="" />
                            </a>
                        </div>
                    </div>
                    <div className="md:w-3/5">
                        <form className="grid grid-flow-row " name="contact" method="POST" data-netlify="true">
                            <input  className="input"type="text" name="name" placeholder="Enter Name" required />
                            <input  className="input"type="email" name="email"  placeholder="Enter Email" required/>
                            <label htmlFor="Message" >Enter Message:</label>
                            <input type="text" name="message" className="input" />
                            <button className="mt-2 text-white  bg-gradient-to-r from-indigo-500 via-purple-500 to-purple-700 hover:bg-purple-500 py-2 px-2" type="submit" >Send Message</button>
                        </form>
                    </div>
                </div>
                </div>
     </section>
    )
}
export default Contact;